import React, {useEffect, useMemo, useState} from 'react';
import {connect} from 'react-redux';
import {Controller, useForm} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import Buttons from '../../../../../components/Buttons';
import {get} from '../../../../../../../../../../../services';
import RadioButtons from '../../../../../components/RadioButtons';
import AmountButtonsInput from '../../../../../components/AmountButtonsInput';
import {FieldSetCheckBoxes} from '../../../../../components/FieldSetCheckBoxes';
import {
  ReactSelect,
  findReactSelectInitialOptions
} from '../../../../../../../../../../../components/ReactSelect';

import './style.less';
import {updatePropertyActions} from '../../../../../../../../../../../redux/actions/updatePropertyActions';
import {useAuth} from "../../../../../../../../../../../services/authServices";
import Check from "../../../../../../../../../../../components/svg/Check";
import {usePlatform} from "../../../../../../../../../../../context/PlatformContext";
import {listing_colors} from "../../../../room_details/RoomsMain2.2_2.4.js/components/RoomDetails";

const pageLabel = 'main_page.my_ads.create_ad.house_details.property_details.level3';

const ApartmentRoomsInfo = ({
                              register,
                              property,
                              errors,
                              watch,
                              setValue,
                              control,
                              hide,
                              setHasRoomsValue
                            }) => {
  const {t} = useTranslation();

  const radioButtonsHasRooms = [{buttonValue: 'true', label: pageLabel + '.has_rooms.true'},
    {buttonValue: 'false', label: pageLabel + '.has_rooms.false'}];

  const watchHasRooms = watch('has_rooms');
  const watchBedrooms = watch('bedrooms');

  let disabledHasRooms = property.hasOwnProperty('has_rooms') && watchBedrooms > 1 && property.hasOwnProperty('bedrooms') && property.bedrooms > 1;

  return (
    <div className={'ApartmentRoomsInfo'}>
      {property.accommodation === 'apartment' && <div className={'input_container input_info' + (hide ? ' hidden' : '')}>
        <label htmlFor={'has_rooms'}>{t(pageLabel + '.has_rooms.label')}</label>
        <RadioButtons radioButtons={radioButtonsHasRooms} name={'has_rooms'}
                      watchValue={watchHasRooms}
                      disabled={disabledHasRooms}
                      setValue={setHasRoomsValue}
                      value={property.hasOwnProperty('has_rooms') ? (property.has_rooms + "") : 'true'}
                      className={'double'} control={control}/>
        {disabledHasRooms && <p className={'warning_message'}>{t(pageLabel + '.has_rooms.disabled_text')}</p>}
      </div>}


      {(property.accommodation === 'rooms' || (property.accommodation === 'apartment' && watchHasRooms === 'true')) &&
       <div
         className={`${property.accommodation === 'apartment' ? 'input_container_double input_info' : ''}` + (hide ? ' hidden' : '')}>
         <div className={'input_container'}>
           <label htmlFor={'bedrooms'}>{`${t(pageLabel + '.bedrooms.label')}`}</label>
           <AmountButtonsInput
             name={'bedrooms'} value={property.bedrooms ? property.bedrooms : null}
             placeholder={'Ex 4'} min={property.bedrooms ? property.bedrooms : 1} amount={1}
             watchValue={watchBedrooms} setValue={setValue}
             className={`${errors.bedrooms ? 'input_error' : null} input_field`}
             register={register({
               validate: value => value > 0 || t(pageLabel + '.bedrooms.required'),
               valueAsNumber: true
             })}
             id={'bedrooms'}
           />
           {errors.bedrooms && <p className={'error_message'}>{errors.bedrooms?.message}</p>}
           {property.accommodation === 'rooms' && <p className={'info'}>{t('visible_on_your_adds')}</p>}
         </div>


         <div className={'input_container'}>
           <label htmlFor={'renting'}>{t(pageLabel + `.renting_${property.accommodation}.label`)}</label>
           <AmountButtonsInput
             name={'renting'}
             value={property.renting ? property.renting : null}
             placeholder={'Ex 4'}
             min={property.renting ? property.renting : 1}
             max={watchBedrooms}
             amount={1}
             className={`${errors.renting ? 'input_error' : null} input_field`}
             watchValue={watch('renting')} setValue={setValue}
             register={register({
               validate: value => value > 0 || t(pageLabel + `.renting_${property.accommodation}.required`),
               valueAsNumber: true
             })}
             id={'renting'}
           />
           {errors.renting && <p className={'error_message'}>{errors.renting?.message}</p>}
           {<p
             className={'info'}>{property.accommodation === 'apartment' ? t(pageLabel + '.renting_rooms.info') : t('visible_on_your_adds')}</p>}
         </div>
       </div>}

      <div className={'input_container input_info' + (hide ? ' hidden' : '')}>
        <label htmlFor={'people'}>{`${t(pageLabel + '.people.label')}`}</label>
        <AmountButtonsInput
          name={'people'} value={property.people ? property.people : null} placeholder={'Ex 4'}
          min={1} amount={1}
          className={`${errors.people ? 'input_error' : null} input_field`}
          register={register({
            validate: value => value > 0 || `${t(pageLabel + '.people.required')}`,
            valueAsNumber: true
          })}
          watchValue={watch('people')} setValue={setValue}
          id={'people'}
        />
        {errors.people && <p className={'error_message'}>{errors.people?.message}</p>}
        {<p className={'info'}>{t('visible_on_your_adds')}</p>}
      </div>
    </div>
  )
};

const ResidenceInfo = ({register, errors, property, watch, setValue, hide}) => {
  const {t} = useTranslation();

  const watchStudioRooms = watch('studio_rooms');
  const watchBedrooms = watch('bedrooms');
  const watchStudioTypes = watch('studio_types');
  const watchBedRoomTypes = watch('bedroom_types');

  const validateBedroomsValues = value => (value + watchStudioRooms + watchBedrooms) > 0 || t(pageLabel + `.residence_studio_rooms.required`);
  const validateBedroomsTypesValues = value => (value + watchStudioTypes + watchBedRoomTypes) > 0 || t(pageLabel + `.residence_studio_types.required`);

  return (
    <div className={'ResidenceInfo' + (hide ? ' hidden' : '')}>
      <div className={'input_container_double input_info'}>
        <div className={'input_container'}>
          <label htmlFor={'studio_rooms'}>{`${t(pageLabel + '.residence_studio_rooms.label')}`}</label>
          <AmountButtonsInput
            name={'studio_rooms'} value={property.studio_rooms ? property.studio_rooms : null}
            placeholder={'Ex 4'} min={0}
            amount={1} className={`${errors.studio_rooms && errors.bedrooms ? 'input_error' : null} input_field`}
            register={register({validate: validateBedroomsValues, valueAsNumber: true})}
            id={'studio_rooms'}
            watchValue={watchStudioRooms} setValue={setValue}
          />
        </div>


        <div className={'input_container'}>
          <label htmlFor={'bedrooms'}>{`${t(pageLabel + '.residence_studio_bedrooms.label')}`}</label>
          <AmountButtonsInput
            name={'bedrooms'}
            value={property.bedrooms ? property.bedrooms : null}
            placeholder={'Ex 4'} min={0} id={'bedrooms'}
            amount={1}
            className={`${errors.bedrooms && errors.studio_rooms ? 'input_error' : null} input_field`}
            watchValue={watchBedrooms} setValue={setValue}
            register={register({validate: validateBedroomsValues, valueAsNumber: true})}/>
        </div>
        {(errors.studio_rooms && errors.bedrooms) && <p
          className={'error_message'}>{errors.studio_rooms ? errors.studio_rooms.message : errors.bedrooms?.message}</p>}
        {<p className={'info'}>{t(pageLabel + '.residence_studio_rooms.info1')}</p>}
        {<p className={'info'}>{t(pageLabel + '.residence_studio_rooms.info2')}</p>}
      </div>

      <div className={'input_container_double input_info'}>
        <div className={'input_container'}>
          <label htmlFor={'studio_types'}>{`${t(pageLabel + '.residence_studio_types.label')}`}</label>
          <AmountButtonsInput
            name={'studio_types'} value={property.studio_types ? property.studio_types : null}
            placeholder={'Ex 4'} min={0} amount={1}
            className={`${errors.studio_types && errors.bedroom_types ? 'input_error' : null} input_field`}
            register={register({validate: validateBedroomsTypesValues, valueAsNumber: true})}
            id={'studio_types'}
            watchValue={watchStudioTypes} setValue={setValue}/>
          {errors.studio_types && <p className={'error_message'}>{errors.bedroom_types?.message}</p>}
          {<p className={'info'}>{t(pageLabel + '.residence_studio_types.info')}</p>}
        </div>


        <div className={'input_container input_info'}>
          <label htmlFor={'bedroom_types'}>{`${t(pageLabel + '.residence_studio_bedroom_types.label')}`}</label>
          <AmountButtonsInput
            name={'bedroom_types'} value={property.bedroom_types ? property.bedroom_types : null}
            placeholder={'Ex 4'} min={0} amount={1}
            className={`${errors.studio_types && errors.bedroom_types ? 'input_error' : null} input_field`}
            register={register({validate: validateBedroomsTypesValues, valueAsNumber: true})}
            id={'bedroom_types'}
            watchValue={watchBedRoomTypes} setValue={setValue}/>
          {(errors.studio_types && errors.bedroom_types) && <p
            className={'error_message'}>{errors.studio_types ? errors.studio_types.message : errors.bedroom_types?.message}</p>}
          {<p className={'info'}>{t(pageLabel + '.residence_studio_bedroom_types.info')}</p>}
        </div>
      </div>
    </div>
  )
};

const PropertyDetails3 = ({updateProperty, currentLevel, property, changePage, defineUpdateFunc}) => {

  const {t} = useTranslation();
  const {user, setUser} = useAuth();
  const {platform} = usePlatform();

  const handlePropertyFieldChange = (field, value) => {
    if(field === "features" || field === "closeUniversities" || field === "closeMetroLines") {
      setChangedSelects(true);
    }
    setCurrentProperty(prevState => ({...prevState, [field]: value}))
  };

  let adjectivesNames = ['luminous', 'spacious', 'modern', 'new', 'comfortable', 'bright', 'cozy', 'renovated'];

  const radioButtonsMobilated = [{id: 'mobilated', buttonValue: 'true', label: pageLabel + '.mobilated.true'},
    {id: 'non_mobilated', buttonValue: 'false', label: pageLabel + '.mobilated.false'}];

  const radioButtonsColiving = [{id: 'coliving', buttonValue: 'true', label: pageLabel + '.coliving.true'},
    {id: 'non_coliving', buttonValue: 'false', label: pageLabel + '.coliving.false'}];

  let featuresOptions = useMemo(() => ['downtown', 'metroBus', 'foreigners', 'young', 'nightlife', 'restaurants', 'greenAreas', 'quiet', 'beach', 'bikeLanes', 'coworking', 'river', 'gyms', 'sights', 'venues'].map(option => ({
    value: option,
    label: t(pageLabel + '.features.' + option)
  })), []);
  let [universitiesOptions, setUniversitiesOptions] = useState([]);
  let metroLinesOptions = useMemo(() => {
    const metro_regions = {
      "lisboa": ['blue', 'yellow', 'red', 'green'],
      "almada": ['blue', 'yellow', 'green'],
      "porto": ['blue', 'yellow', 'red', 'green', 'orange', 'violet', 'pink'],
      "barcelona": ['1', '2', '3', '4', '5', '9n', '9s', '10n', '10s', '11', 'fm'],
      "madrid": ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', 'r', 'r1', 'r2', 'r3'],
      "milan": ['1', '2', '3', '9', '10', '12', '14', '15', '16', '13', '24', '27', 'M1', 'M2', 'M3', 'M4', 'M5'],
      "roma": ['A', 'B', 'C', '2', '3', '5', '8', '14', '19'],
      "sevilla": ['1'],
      "valencia": ['1', '2', '3', '4', '5', '6', '7', '8', '9']
    };
    return (metro_regions[property.region.toLowerCase()]||[]).map(option => ({
      value: option,
      label: ["barcelona", "madrid", "milan", "roma", "sevilla", "valencia"].includes(property.region.toLowerCase()) ? option.toUpperCase() : t(pageLabel + '.metro_lines.' + option) //TODO translate barcelona and madrid lines
    }));
  }, [property.region]);

  const [changedSelects, setChangedSelects] = useState(false);

  const [currentProperty, setCurrentProperty] = useState(() => {
    let ret = {
      ...property,
      internal_name: property.internal_name ? property.internal_name : null,
      adjectives: property.adjectives ? property.adjectives : [],
      features: findReactSelectInitialOptions(property.features ? property.features : [], featuresOptions),
      closeUniversities: findReactSelectInitialOptions(property.universities ? (property.universities.length > 3 ? property.universities.slice(0, 3) : property.universities) : [], universitiesOptions),
      closeMetroLines: findReactSelectInitialOptions(property.metro_lines ? (property.metro_lines.length > 3 ? property.metro_lines.slice(0, 3) : property.metro_lines) : [], metroLinesOptions)
    }
    if (property.accommodation === 'apartment' && property.hasOwnProperty("rooms") && property.rooms['room_1']) {
      if (property.rooms['room_1'].externalName) ret.externalName = property.rooms['room_1'].externalName;
      if (property.rooms['room_1'].listingColor) ret.listingColor = property.rooms['room_1'].listingColor;
      if (property.rooms['room_1'].overrideTitle) ret.overrideTitle = property.rooms['room_1'].overrideTitle;
      if (property.rooms['room_1'].overrideDescription) ret.overrideDescription = property.rooms['room_1'].overrideDescription;
    }
    return ret;
  });

  const onSubmit = async (values) => {
    values.universities = currentProperty.closeUniversities ? currentProperty.closeUniversities.map(value => value.label) : [];
    values.metro_lines = currentProperty.closeMetroLines ? currentProperty.closeMetroLines.map(value => value.value) : [];
    values.features = currentProperty.features ? currentProperty.features.map(value => value.value) : [];
    values.adjectives = currentProperty.adjectives;

    values.mobilated = values.mobilated === 'true';
    values.coliving = values.coliving === 'true';

    if(!values.bedrooms) values.bedrooms = 1;

    if (property.accommodation === 'apartment') {
      values.has_rooms = values.has_rooms === 'true';
      if(!values.renting) values.renting = 1;
    } else if(property.accommodation === "rooms") {
      values.has_rooms = true;
    }
    await updateProperty(values, currentLevel);
    if (property.accommodation === 'rooms' && values.renting) {
      setUser(prev => ({...prev, inProgressListings: prev.inProgressListings + (values.renting -1)}));
    }else if(values.bedroom_types || values.studio_types){
      setUser(prev => ({...prev, inProgressListings: prev.inProgressListings + (values.bedroom_types ? values.bedroom_types : 0) + (values.studio_types ? values.studio_types : 0)}));
    }
    setChangedSelects(false);
  };

  useEffect(() => {
    // get the university options to pass to the ReactSelectMulti
    if (!property.region) return;
    (async () => {
      let nextUniversitiesOptions = (await get('/data/universities'))[property.region.toLowerCase()]?.map(university => ({
        label: university,
        value: university
      }));
      setUniversitiesOptions(nextUniversitiesOptions);
      setCurrentProperty(prevState => {
        return {
          ...prevState,
          closeUniversities: findReactSelectInitialOptions(property.universities ? property.universities : [], nextUniversitiesOptions),
        }
      })
    })();
  }, [property.region]);

  const {handleSubmit, register, errors, watch, setValue, control, formState} = useForm({shouldFocusError: true});

  useEffect(() => defineUpdateFunc(async () => new Promise(async (resolve) => {
    if (!changedSelects && !formState.isDirty) return resolve();
    await handleSubmit(async (values) => {
      await onSubmit(values);
      resolve();
    }, resolve)()
  })), [currentProperty, formState.isDirty, changedSelects]);

  useEffect(() => {
    if (errors) {
      const anchor = document.querySelector(`#${Object.keys(errors)[0]}`);
      if (anchor) anchor.scrollIntoView({behavior: 'smooth', block: 'center'})
    }
  }, [errors]);

  return (
    <div className={'PropertyDetails3'}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={'scrollable'}>
          {/*internal_name*/}
          <div className={'input_container input_info'}>
            <label htmlFor={'internal_name'}>{`${t(pageLabel + '.internal_name.label')}`}</label>
            <input name="internal_name" placeholder={`Ex: Casa Alcântara`}
                   className={`basic_container ${errors.internal_name ? 'input_error' : null} input_field`}
                   defaultValue={currentProperty.internal_name}
                   ref={register({
                     required: `${t(pageLabel + '.internal_name.required')}`,
                     minLength: {value: 1, message: `${t(pageLabel + '.internal_name.minLength')}`}
                   })}/>
            {errors.internal_name && <p className={'error_message'}>{errors.internal_name?.message}</p>}
            {<p className={'info'}>{t('visible_for_you')}</p>}
          </div>

          {property.accommodation === 'apartment' && <div className={'input_container input_info'}>
            <label htmlFor={'externalName'}>{t('main_page.my_ads.create_ad.room_details.room_details.externalName.label')}</label>
            <input name="externalName" placeholder={t('main_page.my_ads.create_ad.room_details.room_details.externalName.placeholder')}
                   className={`basic_container ${errors.externalName ? 'input_error' : null} input_field`}
                   defaultValue={currentProperty.externalName}
                   ref={register()}/>
            {<p className={'info'}>{t('main_page.my_ads.create_ad.room_details.room_details.externalName.info')}</p>}
          </div>}

          {(property.accommodation === 'apartment' && platform?.functionalities?.includes("listing_color")) && <div className={"ListingColorPicker input_container"}>
            <label>{t('main_page.my_ads.create_ad.room_details.room_details.listingColor.label')}</label>
            <Controller control={control} name="listingColor" defaultValue={currentProperty.listingColor} render={() => (
                <div className={"colors-container"}>
                  {listing_colors.map((color, index) => (
                      <div key={index} className={`color-circle ${currentProperty.listingColor === color ? 'selected' : ''}`}
                           style={{backgroundColor: color}}
                           onClick={() => {
                             handlePropertyFieldChange('listingColor', color);
                             setValue('listingColor', color, { shouldDirty: true });
                           }}>
                        {currentProperty.listingColor === color && <Check />}
                      </div>
                  ))}
                  <div className={`color-circle ${!currentProperty.listingColor ? 'selected' : ''} no-color-circle`}
                       title={t('main_page.my_ads.create_ad.room_details.room_details.listingColor.noColor')}
                       onClick={() => {
                         handlePropertyFieldChange('listingColor', null);
                         setValue('listingColor', null, { shouldDirty: true });
                       }}>
                    {!currentProperty.listingColor && <Check />}
                  </div>
                </div>)}/>
            {<p className={'info'}>{t('main_page.my_ads.create_ad.room_details.room_details.listingColor.info')}</p>}
          </div>}

          {property.accommodation === 'apartment' && <div className={'input_container input_info'}>
            <label htmlFor={'overrideTitleSwitch'}>{t('main_page.my_ads.create_ad.room_details.room_details.overrideTitle.label')}</label>
            <RadioButtons radioButtons={[{id: 'overrideTitle', buttonValue: 'true', label: 'yes'},
              {id: 'no_overrideTitle', buttonValue: 'false', label: 'no'}]} name={'overrideTitleSwitch'}
                          value={currentProperty.hasOwnProperty('overrideTitle')||currentProperty.hasOwnProperty('overrideDescription') ? 'true' : 'false'}
                          className={'double'} control={control} rules={{required: true}}/>
            {watch("overrideTitleSwitch") === 'true' && <>
              {["en", "pt", "it", "es"].map(lang => {
                return <div className={'input_container input_info override-title-wrapper'} key={lang}>
                  <label>{lang.toUpperCase()} <img alt={lang} src={`https://github.com/madebybowtie/FlagKit/raw/master/Assets/PNG/${(lang === "en" ? "gb" : lang).toUpperCase()}@2x.png?raw=true)`}/></label>
                  <input name={`overrideTitle_${lang}`} placeholder={t('main_page.my_ads.create_ad.room_details.room_details.overrideTitle.titlePlaceholder', {lang: lang.toUpperCase()})}
                         className={`basic_container ${errors[`overrideTitle_${lang}`] ? 'input_error' : null} input_field`}
                         defaultValue={currentProperty.overrideTitle ? currentProperty.overrideTitle[lang] : ''}
                         ref={register()}/>
                  {errors[`overrideTitle_${lang}`] && <p className={'error_message'}>{errors[`overrideTitle_${lang}`].message}</p>}
                  <textarea name={`overrideDescription_${lang}`} placeholder={t('main_page.my_ads.create_ad.room_details.room_details.overrideTitle.descriptionPlaceholder', {lang: lang.toUpperCase()})} rows={4}
                            className={`basic_container ${errors[`overrideDescription_${lang}`] ? 'input_error' : null} input_field textarea_field`}
                            defaultValue={currentProperty.overrideDescription ? currentProperty.overrideDescription[lang] : ''}
                            ref={register()}/>
                  {errors[`overrideDescription_${lang}`] && <p className={'error_message'}>{errors[`overrideDescription_${lang}`].message}</p>}
                </div>
              })}
            </>}
          </div>}

          <div className={'input_container'}>
            <label htmlFor={'area'}>{`${t(pageLabel + '.size.label')}`}</label>
            <input name="area" type="number" defaultValue={currentProperty.area}
                   placeholder={`Ex: 70 m2`} className={`basic_container input_field`}
                   ref={register({valueAsNumber: true})} onWheel={(e) => e.target.blur()}
            />
          </div>

          {/*hasRooms bedrooms renting people*/}
          {currentProperty.accommodation !== 'residence' &&
           <ApartmentRoomsInfo register={register} property={currentProperty} errors={errors} watch={watch}
                               setValue={setValue} control={control}
                               setHasRoomsValue={(value) => handlePropertyFieldChange('has_rooms', value)}
                               handlePropertyFieldChange={handlePropertyFieldChange}
           />}

          {/*studio_rooms bedrooms studio_types bedroom_types*/}
          {currentProperty.accommodation === 'residence' &&
           <ResidenceInfo register={register} errors={errors} property={currentProperty} watch={watch}
                          setValue={setValue}/>}


          {/*mobilated*/}
          <div className={'input_container'}>
            <label htmlFor={'mobilated'}>{`${t(pageLabel + '.mobilated.label')}`}</label>
            <RadioButtons radioButtons={radioButtonsMobilated} name={'mobilated'} value={'true'}
                          error={errors.mobilated}
                          className={'double'}
                          control={control}/>
            <p className={'info'}>{t(pageLabel + '.mobilated.info')}</p>
          </div>

          {/*coliving*/}
          {(currentProperty.accommodation === 'rooms' || currentProperty.accommodation === 'residence' )&&
          <div className={'input_container'}>
            <label htmlFor={'coliving'}>{`${t(pageLabel + '.coliving.label')}`}</label>
            <RadioButtons radioButtons={radioButtonsColiving} name={'coliving'} value={currentProperty.coliving || 'false'}
                          register={register}
                          error={errors.coliving}
                          className={'double'}
                          control={control}/>
          </div>}


          {/*adjectives*/}
          <div className={'input_checkboxes input_container'}>
            <label htmlFor={'adjectives'}>{`${t(pageLabel + '.adjectives.label')}`}</label>
            <FieldSetCheckBoxes t={t} checkBoxesNames={adjectivesNames} name={'adjectives'}
                                register={register} type={'basic_container'}
                                amountInLine={'four-in-line'} values={currentProperty.adjectives}
                                setValues={(value) => handlePropertyFieldChange('adjectives', value)}
                                defaultObjectLabel={(value) => 'main_page.my_ads.create_ad.adjectives.' + value}/>
          </div>


          <div className={'input_container_double'} id={'distances'}>
            {/*distMetro*/}
            <div className={'input_container'}>
              <label htmlFor={'distMetro'}>{`${t(pageLabel + '.distMetro.label')}`}</label>
              <AmountButtonsInput
                name={'distMetro'} value={currentProperty.distMetro} placeholder={'Ex 5min'}
                min={1}
                amount={1}
                units={'min'}
                id={'distMetro'}
                className={`${errors.distMetro ? 'input_error' : null} input_field`} watchValue={watch('distMetro')}
                setValue={setValue}
                register={register({
                  validate: value => value > 0 || t(pageLabel + '.distMetro.required'),
                  valueAsNumber: true
                })}/>
              {errors.distMetro && <p className={'error_message'}>{errors.distMetro?.message}</p>}
            </div>

            {/*distSupermarket*/}
            <div className={'input_container'}>
              <label htmlFor={'distSupermarket'}>{`${t(pageLabel + '.distSupermarket.label')}`}</label>
              <AmountButtonsInput
                name={'distSupermarket'} value={currentProperty.distSupermarket} placeholder={'Ex 5min'} min={0}
                amount={1}
                units={'min'}
                className={`${errors.distSupermarket ? 'input_error' : null} input_field`}
                watchValue={watch('distSupermarket')} setValue={setValue}
                register={register({
                  validate: value => value > 0 || t(pageLabel + '.distSupermarket.required'),
                  valueAsNumber: true
                })}
              />
              {errors.distSupermarket && <p className={'error_message'}>{errors.distSupermarket?.message}</p>}
            </div>
          </div>

          {/*universities*/}
          <div className={'Select input_container'}>
            <label htmlFor={'universities'} className={'no_margin'}>{t(pageLabel + '.universities.label')}</label>
            <p className={'info'}>{t(pageLabel + '.three_options')}</p>
            <ReactSelect key={'universities'}
                         isMulti={true}
                         maxLength={3}
                         value={currentProperty.closeUniversities} options={universitiesOptions}
                         onChange={(value) => handlePropertyFieldChange('closeUniversities', value)}/>
          </div>

          {/*/!*metro_lines*!/*/
            ["lisboa", "porto", "barcelona", "madrid", "milan", "roma", "sevilla", "valencia"].includes(property.region.toLowerCase()) &&
          <div className={'input_container'}>
            <label htmlFor={'metro_lines'}>{`${t(pageLabel + '.metro_lines.label')}`}</label>
            <ReactSelect key={'metro_lines'} isMulti={true}
                         maxLength={3}
                         value={currentProperty.closeMetroLines} className={'Select'} options={metroLinesOptions}
                         onChange={(value) => handlePropertyFieldChange('closeMetroLines', value)}/>
          </div>
          }

          {/*/!*features*!/*/}
          <div className={'input_container'}>
            <label htmlFor={'features'} className={'no_margin'}>{t(pageLabel + '.features.label')}</label>
            <p className={'info'}>{t(pageLabel + '.three_options')}</p>
            <ReactSelect key={'features'} isMulti={true}
                         maxLength={3}
                         value={currentProperty.features} className={'Select'}
                         options={featuresOptions}
                         onChange={(value) => handlePropertyFieldChange('features', value)}/>
          </div>

        </div>
        <Buttons changePage={changePage} saveAndExit={handleSubmit(v => onSubmit({...v, saveAndExit: true}))}/>
      </form>
    </div>
  );

};

const actionCreator = {
  defineUpdateFunc: updatePropertyActions.defineUpdateFunc
};

export default connect(null, actionCreator)(PropertyDetails3);

